import { Pressable } from '@react-aria/interactions'
import { Text } from 'blaze-ui/Text/Text'
import { Trash2 } from 'blaze-ui/icons'
import { Drawer } from 'components/Drawer'
import { DrawerProps } from 'components/Drawer/Root'
import ThreeDotMenuDrawerStyles from 'screens/VirtualMarketerOnboarding/ThreeDotMenuDrawer/ThreeDotMenuDrawer.module.scss'

interface Props extends DrawerProps {
  onDelete: () => void
}

export const SettingsDrawer = ({ onDelete, ...drawerProps }: Props) => {
  return (
    <Drawer.Root {...drawerProps} handleOnly>
      <Drawer.Portal>
        <Drawer.Content>
          <Drawer.InnerContent>
            <Drawer.Top>
              <div />
              <div />
              <Drawer.Close variant="ghost" position="right" />
            </Drawer.Top>
            <div className={ThreeDotMenuDrawerStyles.content}>
              <Pressable onPress={onDelete}>
                <div className={ThreeDotMenuDrawerStyles.item}>
                  <Trash2 />
                  <Text>Delete</Text>
                </div>
              </Pressable>
            </div>
          </Drawer.InnerContent>
        </Drawer.Content>
        <Drawer.Overlay />
      </Drawer.Portal>
    </Drawer.Root>
  )
}
